var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "yxtbiz-select-kng-catalog-v2" }, [
    _c(
      "div",
      {
        staticClass: "yxtbiz-select-kng-catalog-v2__main-content",
        class: { pr280: _vm.isShowCheckedList },
      },
      [
        _vm.isShowSearch
          ? _c("yxt-input", {
              staticClass: "mb16 yxtbiz-select-kng-catalog-v2__search",
              attrs: {
                placeholder: _vm.$t(
                  "pc_biz_kng_lbl_search_category_name" /* 搜索分类名称 */
                ),
                maxlength: "20",
                searchable: "",
              },
              on: { search: _vm.searchCatalog },
              model: {
                value: _vm.searchCatalogName,
                callback: function ($$v) {
                  _vm.searchCatalogName = $$v
                },
                expression: "searchCatalogName",
              },
            })
          : _vm._e(),
        _c("yxtbiz-funs-tree", {
          directives: [
            {
              name: "loading",
              rawName: "v-loading",
              value: _vm.treeLoading,
              expression: "treeLoading",
            },
          ],
          ref: "tree",
          attrs: {
            data: _vm.treeData,
            virtual: "",
            keeps: 50,
            buffer: 10,
            "node-key": "id",
            "default-expanded-keys": _vm.defaultExpandCatalog,
            "default-checked-keys": _vm.defaultCheckKeys,
            props: _vm.defaultProps,
            "highlight-current": !_vm.showCheckbox,
            "show-checkbox": _vm.showCheckbox,
            "check-strictly": _vm.checkStrictly,
            wrapWidth: _vm.wrapWidth,
            functionsRender: _vm.functionsRenderMid,
            "filter-node-method": _vm.filterCatalogNode,
          },
          on: { "node-click": _vm.nodeClick, check: _vm.handlerCheck },
        }),
      ],
      1
    ),
    _vm.isShowCheckedList
      ? _c(
          "div",
          { staticClass: "yxtbiz-select-kng-catalog-v2__checked-list" },
          [
            _c(
              "div",
              {
                staticClass:
                  "yxtbiz-select-kng-catalog-v2__checked-list-header",
              },
              [
                _c("span", [
                  _vm._v(
                    _vm._s(_vm.$t("pc_biz_labelling_selected" /** 已选： */)) +
                      " " +
                      _vm._s(_vm.selectData.length)
                  ),
                ]),
                _vm.showClearAllBtn
                  ? _c(
                      "yxt-button",
                      { attrs: { type: "text" }, on: { click: _vm.clearAll } },
                      [
                        _vm._v(
                          _vm._s(
                            _vm.$t("pc_biz_labelling_clearall" /** 清空 */)
                          )
                        ),
                      ]
                    )
                  : _vm._e(),
              ],
              1
            ),
            _c(
              "div",
              {
                staticClass:
                  "yxtbiz-select-kng-catalog-v2__checked-list-content mt16",
              },
              [
                _vm._l(_vm.showData, function (item, key) {
                  return _c(
                    "yxt-tag",
                    {
                      key: key,
                      staticClass: "mr5 mb6",
                      attrs: {
                        size: "small",
                        type: "info",
                        disableTransitions: true,
                        closable: "",
                      },
                      on: {
                        close: function ($event) {
                          return _vm.deleteItem(item)
                        },
                      },
                    },
                    [
                      _c(
                        "yxt-tooltip",
                        {
                          attrs: {
                            effect: "dark",
                            placement: "top",
                            content: item.label,
                          },
                        },
                        [_c("span", [_vm._v(_vm._s(item.label))])]
                      ),
                      item.includeAll === 1
                        ? _c("span", { staticClass: "ml8 color-gray-6" }, [
                            _vm._v(
                              _vm._s(
                                _vm.$t("biz_udp_subsequent_all" /** 后续全部 */)
                              )
                            ),
                          ])
                        : _vm._e(),
                    ],
                    1
                  )
                }),
                _vm.showCount < _vm.selectData.length
                  ? _c(
                      "div",
                      [
                        _c(
                          "yxt-tag",
                          {
                            staticClass: "pointer",
                            attrs: {
                              size: "small",
                              type: "info",
                              disableTransitions: true,
                            },
                            on: {
                              click: function () {
                                _vm.showCount += 50
                              },
                            },
                          },
                          [
                            _c("span", { staticClass: "checkedlist-tag" }, [
                              _vm._v(
                                _vm._s(
                                  _vm.$t("biz_pc_expand_more" /** 展开更多 */)
                                )
                              ),
                            ]),
                            _c("i", { staticClass: "yxt-icon-arrow-down ml6" }),
                          ]
                        ),
                      ],
                      1
                    )
                  : _vm._e(),
                _vm.showCount > _vm.selectData.length &&
                _vm.selectData.length > 6
                  ? _c(
                      "div",
                      [
                        _c(
                          "yxt-tag",
                          {
                            staticClass: "pointer",
                            attrs: {
                              size: "small",
                              type: "info",
                              disableTransitions: true,
                            },
                            on: {
                              click: function () {
                                _vm.showCount = 6
                              },
                            },
                          },
                          [
                            _c("span", { staticClass: "checkedlist-tag" }, [
                              _vm._v(
                                _vm._s(
                                  _vm.$t("app_common_yxt_btn_close" /** 收起 */)
                                )
                              ),
                            ]),
                            _c("i", { staticClass: "yxt-icon-arrow-up ml6" }),
                          ]
                        ),
                      ],
                      1
                    )
                  : _vm._e(),
              ],
              2
            ),
          ]
        )
      : _vm._e(),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }